import { createRouter } from '@tanstack/react-router';

import { routeTree } from '@/routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  // OFF. A client route change swaps instantly; only the page's own content
  // animates (skeletons, card entrances), and the background, nav and tab bar
  // never move.
  //
  // This was `true`, cross-fading the whole document. Three separate defects
  // came out of that, each fixed and each replaced by the next, all measured
  // with scripts/measure-client-nav.mjs on a dashboard→library tap:
  //   1. the page wash is opaque and, being view-transition-named, painted
  //      ABOVE the root snapshot — 27 frames (~271ms) showing neither the old
  //      page nor the new one, just background.
  //   2. pinning root instead put body's opaque --color-background over the
  //      wash and sky band, so the blue sky flattened to grey mid-navigation.
  //   3. naming <main> so only it animated meant the group animated main's
  //      BOX, which swings 4357px (library) to 2092px (assessments) — the
  //      outgoing snapshot is scaled into that shrinking box and smears across
  //      the viewport, drifting a pure-background column by 29 mean channel
  //      values over 260ms.
  //
  // All three are the same shape of problem: `startViewTransition` snapshots
  // the whole document, and this shell is mostly persistent chrome sitting on
  // a full-bleed gradient, so almost everything it snapshots is something that
  // must NOT move. Measured with it off: zero frames showing neither page, and
  // a pure-background column that does not move at all.
  //
  // It was also never running for most users — `document.startViewTransition`
  // is Chromium-only, so every iOS browser already took this path.
  //
  // If you want a cross-fade back, animate the ROUTE CONTENT inside <main>
  // (a keyframe on the page component), not the document.
  defaultViewTransition: false,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
